import { Injectable } from '@angular/core';
import { Router, CanActivate, CanActivateChild } from '@angular/router';
import {StorageService} from "./storage.service";

@Injectable()
export class AuthGuard implements CanActivate,CanActivateChild  {

  constructor(private router: Router,
              private storageService: StorageService) { }

  canActivate() {
    if (this.storageService.isAuthenticated()) {
        return true;
    }
    this.router.navigate(['/login']);
    return false;
  }
    
  canActivateChild() {
    return this.canActivate();
  }
}

